import { Box, Typography, Link, Divider } from '@mui/material'

const Footer = ({ stacked }) => {
  const year = new Date().getFullYear()

  return (
    <Box sx={{ mt: 'auto' }}>
      {!stacked && <Divider />}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 0.5,
          py: 2.5
        }}
      >
        <Typography variant='caption' color='text.secondary'>
          © {year}{' '}
          <Link href='https://magnitude.io' target='_blank' underline='hover'>
            Magnitude.io
          </Link>
          . All rights reserved.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {[
            { label: 'Terms of Use', href: 'https://magnitude.io/terms-of-use/' },
            { label: 'Privacy Policy', href: 'https://magnitude.io/privacy-policy/' },
            { label: 'Disclaimer', href: 'https://magnitude.io/disclaimer/' }
          ].map(({ label, href }, i, arr) => (
            <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Link href={href} target='_blank' underline='hover' variant='caption' color='text.secondary'>
                {label}
              </Link>
              {i < arr.length - 1 && (
                <Typography variant='caption' color='text.disabled'>|</Typography>
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default Footer
